import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 17h18v2H3zm0-7h18v5H3zm0-4h18v2H3z"
}), 'CalendarViewDay');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CalendarViewDay.js
// module id = 2583
// module chunks = 2